// src/context/BookingContext.js
import React, { createContext, useState, useContext, useEffect, useMemo } from "react";

const BookingContext = createContext();

const STORAGE_KEY = "igd_booking_v2";

const DEFAULT_BOOKING = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  date: "",       // 'YYYY-MM-DD'
  time: [],       // array of "HH:mm"
  attendees: 1,
  paymentComplete: false,
};

export const BookingProvider = ({ children }) => {
  const [bookingDetails, setBookingDetails] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return DEFAULT_BOOKING;

      const parsed = JSON.parse(raw);

      // defensive normalization
      if (!Array.isArray(parsed.time)) parsed.time = [];

      return { ...DEFAULT_BOOKING, ...parsed };
    } catch {
      return DEFAULT_BOOKING;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(bookingDetails));
    } catch {}
  }, [bookingDetails]);

  const setDate = (dateStr) => {
    setBookingDetails((p) => ({ ...p, date: dateStr }));
  };

  const setTimes = (slotsArray) => {
    setBookingDetails((p) => ({
      ...p,
      time: Array.isArray(slotsArray) ? slotsArray : [],
    }));
  };

  const resetBooking = () => setBookingDetails(DEFAULT_BOOKING);

  const value = useMemo(
    () => ({
      bookingDetails,
      setBookingDetails,
      setDate,
      setTimes,
      resetBooking,
    }),
    [bookingDetails]
  );

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};

export const useBooking = () => useContext(BookingContext);